import React, { useEffect, useState } from 'react'
import "../Css/Headar.css"
import HeaderLogo from "../aseets/img/FooterLogo.png"
import { Col, Container, Row } from 'react-bootstrap'
import { FaFacebook,FaInstagram,FaTwitter  } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";


import { Link } from 'react-router-dom'

const Headar = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
          if (window.scrollY > 50) {
            setIsScrolled(true);
          } else {
            setIsScrolled(false);
          }
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);
    
  return (
    <React.Fragment>
        <div className={`headarMainDiv ${isScrolled ? 'scrolled' : ''}`}>
            <Container fluid>
                <Row style={{alignItems:"center"}}>
                    <Col lg={2}>
                   <Link to="/"><img src={HeaderLogo} alt='logo' /></Link>  
                    </Col>
                    <Col lg={10}>
                    <div className='headarLinkDiv'>
                        <div>
                            <Link to="/about-us" >
                            About us
                            </Link>
                        </div>
                        <div>
                            <Link to="/membership" >
                            Membership
                            </Link>
                        </div>
                        <div>
                            <Link to="/testimonial" >
                            Testimonials
                            </Link>
                        </div>
                        <div>
                            <Link to="/contact-us" >
                            Contact us
                            </Link>
                        </div>
                        {/* <div className='shareIconDiv'>
                           <div>
                            <Link to="#">
                             <FaFacebook />
                            </Link>
                           </div>
                           <div>
                            <Link to="#">
                             <FaInstagram  />
                            </Link>
                           </div>
                           <div>
                            <Link to="#">
                             <FaXTwitter  />
                            </Link>
                           </div>
                           
                        </div> */}
                    </div>
                    </Col>
                </Row>
            </Container>
        </div>
    </React.Fragment>
  )
}

export default Headar